module.exports = __webpack_public_path__ + "img/news-historical-01.jpg?005bd4ddbf66642a8f27c7982dd6b023";